import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ComponentWrapper from '../components/Shared/ComponentWrapper';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-gray-50">
      <ComponentWrapper>
        <div className="w-full flex flex-col items-center justify-center py-20 px-4">
          {/* 404 Graphic */}
          <div className="relative mb-8">
            <h1 className="text-[120px] sm:text-[180px] md:text-[220px] font-bold text-blue-1 opacity-10 leading-none">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <img
                src="/assets/logo.svg"
                alt="Helix Logo"
                className="w-[80px] sm:w-[120px] md:w-[150px] h-auto opacity-50"
              />
            </div>
          </div>

          {/* Error Message */}
          <div className="text-center max-w-[600px] mb-8">
            <h2 className="text-[32px] sm:text-[40px] md:text-[48px] font-semibold text-gray-900 mb-4 leading-tight">
              Page Not Found
            </h2>
            <p className="text-[16px] sm:text-[18px] text-gray-600 leading-relaxed mb-8">
              Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center w-full max-w-[500px]">
            <Link
              to="/"
              className="w-full sm:w-auto text-[14px] font-semibold text-white h-[46px] rounded-[12px] bg-blue-1 px-8
                       transition-all duration-200 ease-in-out
                       shadow-md hover:shadow-lg active:shadow-sm
                       transform hover:scale-105 active:scale-95 flex items-center justify-center"
            >
              Go to Homepage
            </Link>
            <button
              onClick={handleGoBack}
              className="w-full sm:w-auto flex border-[1px] border-gray-2 rounded-[12px] h-[46px] px-8 justify-center items-center gap-2 
                      hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 ease-in-out
                      active:scale-95 transform"
            >
              <p className="text-[14px] font-semibold text-blue-1 transition-colors duration-200">
                Go Back
              </p>
            </button>
          </div>

          {/* Quick Links */}
          <div className="mt-12 pt-8 border-t border-gray-200 w-full max-w-[600px]">
            <p className="text-[14px] text-gray-500 text-center mb-4">
              Looking for something? Try these popular links:
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/');
                  setTimeout(() => {
                    const element = document.getElementById('about');
                    if (element) {
                      const offset = 84;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                      });
                    }
                  }, 100);
                }}
                className="text-[14px] text-blue-1 hover:text-blue-2 transition-colors duration-200 px-3 py-1 rounded-lg hover:bg-blue-1/5"
              >
                About
              </a>
              <a
                href="https://ai.helix.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[14px] text-blue-1 hover:text-blue-2 transition-colors duration-200 px-3 py-1 rounded-lg hover:bg-blue-1/5"
              >
                Launch Helix AI
              </a>
              <Link
                to="/docs"
                className="text-[14px] text-blue-1 hover:text-blue-2 transition-colors duration-200 px-3 py-1 rounded-lg hover:bg-blue-1/5"
              >
                Documentation
              </Link>
            </div>
          </div>
        </div>
      </ComponentWrapper>
    </div>
  );
};

export default NotFoundPage;

